"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _Card = _interopRequireDefault(require("../Card"));

var _theme = _interopRequireDefault(require("../../theme"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = (0, _styledComponents.withTheme)((0, _styledComponents["default"])(_Card["default"]).withConfig({
  displayName: "SelectButtons__Button",
  componentId: "fz4upz-0"
})(["color:", ";font-weight:bold;text-align:center;display:flex;align-items:center;justify-content:center;min-height:34px;cursor:pointer;padding:4px;transition:all 250ms ", ";&:hover{background-color:", ";color:", ";}&[data-selected=true]{background-color:", ";color:white;}"], (0, _themeGet["default"])('colors.neutral.500'), _theme["default"].util.transistion, (0, _themeGet["default"])('colors.teal.200'), (0, _themeGet["default"])('colors.teal.900'), (0, _themeGet["default"])('colors.teal.500')));

function SelectButtons(_ref) {
  var children = _ref.children,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["children", "value", "onChange"]);

  var handleButtonClick = function handleButtonClick(v) {
    return function () {
      var e = {
        target: {
          value: v
        }
      };
      onChange(e, v);
    };
  };

  var options = _react["default"].Children.map(children, function (v) {
    var _v$props = v.props,
        buttonValue = _v$props.value,
        label = _v$props.children;
    return _react["default"].createElement(Button, {
      "data-selected": value === buttonValue,
      onClick: handleButtonClick(buttonValue),
      flex: "1",
      borderRadius: 0
    }, label);
  });

  return _react["default"].createElement(_Card["default"], _extends({
    borderRadius: 4,
    overflow: "hidden",
    border: "medium",
    display: "flex"
  }, props), options);
}

SelectButtons.defaultProps = {
  theme: _theme["default"]
};

var _default = (0, _styledComponents.withTheme)(SelectButtons);

exports["default"] = _default;